export default __webpack_public_path__ + "static/media/cirun.d515b98d.png";